export const constants = {
  SIGNIN_START_ENDPOINT: '/api/sign-in-service/v1/sign-in.start',
};
